import React from 'react'
import styles from './Body.module.scss'

function Body({ children }: any) {
  return <div className={styles.root}>{children}</div>
}

export default Body
